<template>
  <div>
    <PageAllow controller="OrderProfit" action="billCostAnalyzeView" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="overflow-y-scroll fill-content-height">

        <div class="mx-4 mb-4">
          <!-- 账单详情 -->
          <v-expansion-panels v-model="billPanels" multiple accordion class="mt-4">
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-card-title class="ms-n4 py-0">
                  {{ $t("billProfit.bill.title") }}
                  <v-spacer />
                </v-card-title>
              </v-expansion-panel-header>
              <v-divider />
              <v-expansion-panel-content>
                <v-row no-gutters class="mt-4 table-style">
                  <v-col cols="12" md="4">
                    <v-card class="pa-2 text-no-wrap" outlined tile>
                      <span class="secondary--text">{{ $t("billProfit.Fields.bill_code") }}{{ $t("Global.colon") }}</span>
                      <span>{{ bill.bill_code }}</span>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-card class="pa-2 text-no-wrap" outlined tile>
                      <span class="secondary--text">{{ $t("billProfit.Fields.bill_created") }}{{ $t("Global.colon") }}</span>
                      <span>{{ bill.created | formatTime }}</span>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-card class="pa-2 text-no-wrap" outlined tile>
                      <span class="secondary--text">{{ $t("billProfit.Fields.bill_type") }}{{ $t("Global.colon") }}</span>
                      <span>{{ bill.bill_type_str }}</span>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-card class="pa-2 text-no-wrap" outlined tile>
                      <span class="secondary--text">{{ $t("billProfit.Fields.order_code") }}{{ $t("Global.colon") }}</span>
                      <span>{{ bill.order_code }}</span>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-card class="pa-2 text-no-wrap" outlined tile>
                      <span class="secondary--text">{{ $t("billProfit.Fields.order_created") }}{{ $t("Global.colon") }}</span>
                      <span>{{ bill.order_created | formatTime }}</span>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-card class="pa-2 text-no-wrap" outlined tile>
                      <span class="secondary--text">{{ $t("billProfit.Fields.status") }}{{ $t("Global.colon") }}</span>
                      <span>{{ bill.status_str }}</span>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-card class="pa-2 text-no-wrap" outlined tile>
                      <span class="secondary--text">{{ $t("billProfit.Fields.fee") }}{{ $t("Global.colon") }}</span>
                      <span>{{ $t("Global.money") }}{{ bill.fee | formatMoney }}</span>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-card class="pa-2 text-no-wrap" outlined tile>
                      <span class="secondary--text">{{ $t("billProfit.Fields.received") }}{{ $t("Global.colon") }}</span>
                      <span>{{ $t("Global.money") }}{{(bill.upSum - bill.downSum) | formatMoney }}</span>
                    </v-card>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- 支付流水 -->
          <v-expansion-panels v-model="billRecordsPanels" multiple accordion class="mt-4">
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-card-title class="ms-n4 py-0">
                  {{ $t("billProfit.record.title") }}
                  <v-spacer />
                </v-card-title>
              </v-expansion-panel-header>
              <v-divider />
              <v-expansion-panel-content>
                <v-data-table
                        :headers="recordHeaders"
                        :items="bill_records"
                        :loading="loading"
                        class="elevation-0"
                        multi-sort
                        hide-default-footer
                >
                  <!-- 支付金额 -->
                  <template v-slot:item.price="{ item }">
                    {{ $t("Global.money") }}{{ item.price | formatMoney }}
                  </template>
                  <!-- 支付时间 -->
                  <template v-slot:item.payment_time="{ item }">
                    <span>
                      {{ item.payment_time ? item.payment_time : item.modified | formatTime }}
                    </span>
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- 商品明细表 -->
          <v-card class="px-4 mt-4">
            <v-toolbar flat class="transparent-background-color">
              <v-row no-gutters align="center">
                <v-toolbar-title class="ms-n2">
                  {{ $t("billProfit.detail.title") }}
                </v-toolbar-title>
                <v-spacer />
              </v-row>
            </v-toolbar>
            <v-divider />
            <v-data-table
              :headers="headers"
              :items="bill_details"
              :search="filter"
              :loading="loading"
              class="elevation-0"
              multi-sort
              hide-default-footer
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  class="transparent-background-color"
                  align-self="center"
                >
                  <v-row no-gutters class="me-n3">
                  <span class="caption secondary--text pt-2">
                    {{
                      $t(
                        "$vuetify.dataFooter.pageText",
                        bill_details
                          ? [
                              bill_details.length > 0 ? 1 : 0,
                              bill_details.length,
                              bill_details.length,
                            ]
                          : [0, 0, 0]
                      )
                    }}
                  </span>
                    <v-row no-gutters>
                      <v-spacer />
                      <v-col cols="12" sm="9" md="8">
                        <v-text-field
                          v-model="filter"
                          clearable
                          hide-details
                          :label="$t('Search.filter')"
                        />
                      </v-col>
                    </v-row>
                  </v-row>
                </v-toolbar>
              </template>
              <template v-slot:item.standard_name="{ item }">
                <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
                  {{ item.standard_name.slice(0, 12) + "......" }}
                </span>
                <span v-else>
                  {{ item.standard_name }}
                </span>
              </template>
              <!-- 单价 -->
              <template v-slot:item.price="{ item }">
                {{ $t("Global.money") }}{{ item.price | formatMoney }}
              </template>
              <!-- 数量 -->
              <template v-slot:item.total_num="{ item }">
                {{ item.total_num | formatTwoDot }}
              </template>
              <template v-slot:item.total_price="{ item }">
                {{ $t("Global.money") }}{{ item.total_price | formatMoney }}
              </template>
              <template v-slot:item.average_cost="{ item }">
                {{ $t("Global.money") }}{{ (item.cost / item.total_num) | formatMoney }}
              </template>
              <!-- 成本 -->
              <template v-slot:item.cost="{ item }">
                {{ $t("Global.money") }}{{ item.cost | formatMoney }}
              </template>
              <!-- 毛利率 -->
              <template v-slot:item.profit_rate="{ item }">
                {{ item.profit_rate | formatTwoDot(true) }}{{ $t("Global.rate") }}
              </template>
            </v-data-table>
          </v-card>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import OrderProfitAnalyze from "@/api/order_profit_analyze";

export default {
  data: () => ({
    bill: [],
    bill_details: [],
    bill_records: [],
    paging: {},
    filter: "",
    billPanels: [0],
    billRecordsPanels: [0],
    loading: false,
    profit_total_rate: 0,
    profit_total: 0,
    cost_total: 0,
    sale_total: 0,
  }),
  components: {
    Breadcrumbs,
    PageAllow,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.profitAnalyze"),
        disabled: false,
        href: "/order-profit",
      },
      {
        text: i18n.t("Nav.billProfit"),
        disabled: true,
      },
    ],
    headers: () => [
      {
        text: i18n.t("billProfit.detail.Fields.material_code"),
        align: "start",
        sortable: false,
        value: "material_code",
      },
      {
        text: i18n.t("billProfit.detail.Fields.material_name"),
        align: "start",
        sortable: false,
        value: "content",
      },
      // 规格
      {
        text: i18n.t("billProfit.detail.Fields.standard_name"),
        align: "start",
        sortable: false,
        value: "standard_name",
      },
      {
        text: i18n.t("billProfit.detail.Fields.category_name"),
        align: "start",
        sortable: false,
        value: "category_name",
      },
      // 单位
      {
        text: i18n.t("billProfit.detail.Fields.unit"),
        align: "start",
        sortable: false,
        value: "unit",
      },
      // 售价
      {
        text: i18n.t("billProfit.detail.Fields.price"),
        align: "end",
        sortable: false,
        value: "price",
      },
      // 数量
      {
        text: i18n.t("billProfit.detail.Fields.total_num"),
        align: "end",
        sortable: false,
        value: "total_num",
      },
      // 销售
      {
        text: i18n.t("billProfit.detail.Fields.total_price"),
        align: "end",
        sortable: false,
        value: "total_price",
      },
      // 成本均单价
      {
        text: i18n.t("billProfit.detail.Fields.average_cost"),
        align: "end",
        sortable: false,
        value: "average_cost",
      },
      // 成本
      {
        text: i18n.t("billProfit.detail.Fields.cost"),
        align: "end",
        sortable: false,
        value: "cost",
      },
      //毛利率
      {
        text: i18n.t("billProfit.detail.Fields.profitRate"),
        align: "end",
        sortable: false,
        value: "profitRate",
      },
    ],
    recordHeaders: () => [
      {
        text: i18n.t("billProfit.record.Fields.bill_record_code"),
        align: "start",
        sortable: false,
        value: "bill_record_code",
      },
      {
        text: i18n.t("billProfit.record.Fields.operation_type"),
        align: "start",
        sortable: false,
        value: "operation_str",
      },
      // 支付方式
      {
        text: i18n.t("billProfit.record.Fields.pay_type"),
        align: "start",
        sortable: false,
        value: "pay_type_str",
      },
      // 金额
      {
        text: i18n.t("billProfit.record.Fields.price"),
        align: "end",
        sortable: false,
        value: "price",
      },
      // 支付时间
      {
        text: i18n.t("billProfit.record.Fields.payment_time"),
        align: "end",
        sortable: false,
        value: "payment_time",
      },
      // 凭证号
      {
        text: i18n.t("billProfit.record.Fields.voucher_code"),
        align: "end",
        sortable: false,
        value: "voucher_code",
      },
      // 备注
      {
        text: i18n.t("billProfit.record.Fields.comment"),
        align: "end",
        sortable: false,
        value: "comment",
      }
    ],
    ...mapState(["settings"]),
  },

  mounted() {
    this.getDistributionMAFromAPI()
  },

  methods: {
    getDistributionMAFromAPI() {
      this.loading = true;
      OrderProfitAnalyze.billCostAnalyzeView(this.$route.params.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.bill = response.data.bill;
            this.bill_details = response.data.bill_details;
            this.bill_records = response.data.bill_records;
          }
          this.loading = false;
        }.bind(this)
      );
    },
  },
  watch: {},
};
</script>

<style>
</style>
